import { createTheme } from '@mui/material/styles';

// Create a custom theme
const theme = createTheme({
  palette: {
    primary: {
      main: '#fb99ca', // Customize your primary color
    },
    secondary: {
      main: '#57b7fb', // Customize your secondary color
    },
    success: {
      main: '#E2DEFF', // Customize your secondary color
    },
    background: {
      default: '#D3D3FF', // Background color#c0b8f6
    },
  },

  breakpoints: {
    values: {
      xs: 0,    // Extra small devices
      sm: 760,  // Mobile screens up to 760px
      md: 960,  // Medium devices start at 960px
      lg: 1280,
      xl: 1920,
    },
  },

 

  typography: {
    fontFamily: 'Arial, sans-serif', // Custom font family
    h1: {
      fontSize: '2.5rem',
      fontWeight: 550,
    },
    h2: {
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    h3: {
      fontSize: '0.8rem',
      fontWeight: 550,
      color: '#57b7fb',   
    },
    h4: {
      fontSize: '1.6rem',
      fontWeight: 750,
      color: '#fb99ca',     
    },
    h5: {  
      fontStyle: 'oblique',  
      fontSize:  "38px", 
      color: '#57b7fb',
      fontWeight: 800,
    },
    h6: {
      fontSize: '1.0rem',
      fontWeight: 550,
      color: '#fb99ca',     
    },
    subtitle1: {
      fontStyle: 'oblique'
    },
    subtitle2: {
      fontSize: '1rem',
      color: '#57b7fb',
      fontWeight: 550,
    },
    body1: {
      fontSize: '1rem'
    },
    body2: {
      color: '#FFF',
      fontStyle: 'oblique',
    },
    
  },
  components: {
    
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          color: "#57b7fb", // This will specifically target the label for radio buttons
        },
      },
    },
  },
  
});

export default theme;